<template>
  <header>
    <div class="top">
      <div class="article">
        <!-- <div class="phone">{{$t("phone")}}：customerservice@newtontutor.hk  
          <a target="blank" href="/room/?teacher_id=15&order_course_id=1&course_name=ALevel&begin_time=1595033100&end_time=1595036700&#/init">test</a>
        </div> -->
        <div class="right">
          <div class="lang-item">
            <span
              class="teacher-change-btn"
              @click="setLang(2)"
              v-if="langData.current !== 2"
              >ENGLISH</span
            >
          </div>
          <div class="lang-item" ref="lang">
            <p @click="langDataShow">
              {{ langData.arr[langData.current]==='ENGLISH'?`${langData.arr[langData.current]} / 中文`:langData.arr[langData.current] }}
            </p>
            <ul class="drop-list" v-show="langData.show">
              <li
                @click="setLang(index)"
                :class="{ on: langData.current === index }"
                v-for="(item, index) in langData.arr"
                :key="index"
              >
                {{ item }}
              </li>
            </ul>
          </div>
          <div v-show="user.loginState">
            <router-link
              v-if="user.userType === 10"
              to="/user/info"
              class="messega"
            >
              <!-- <span class="num">12</span> -->
            </router-link>
            <router-link v-else to="/user/info2" class="messega"> </router-link>
            <div class="user-item" ref="user">
              <div class="user" @click="userDown = !userDown">
                <div class="avatar">
                  <img :src="user.userPhoto" alt="" style="object-fit: cover" />
                </div>
                <span class="username">{{ user.userName }}</span>
              </div>
              <ul class="drop-list drop-list-userinfo" v-show="userDown">
                <li @click="linkto('/user/info')" v-if="user.userType === 10">
                  {{ $t('info') }}
                </li>
                <li @click="linkto('/user/info2')" v-else>{{ $t('info') }}</li>
                <li @click="linkto('/user/changepsw')">
                  {{ $t('common.change') }}
                </li>
                <li @click="loginout">{{ $t('logout') }}</li>
              </ul>
            </div>
          </div>
          <div v-show="!user.loginState">
            <!-- <router-link :to="{path: '/register', query: {type: 1}}" class="link">{{$t("common.teacher")}}</router-link> -->
            <router-link
              :to="{ path: '/register', query: { type: 0 } }"
              class="link"
              >{{ $t('common.student') }}</router-link
            >
            <router-link to="/login" class="link login">{{
              $t('common.login')
            }}</router-link>
          </div>
        </div>
      </div>
    </div>
    <div class="app-logo">
      <router-link to="/home" active-class="on">
        <img src="../assets/logo2.png" alt="" />
      </router-link>
      <div class="app-lang">
        <div class="lang-item">
          <span
            class="teacher-change-btn"
            @click="setLang(2)"
            v-if="langData.current !== 2"
            >ENGLISH</span
          >
        </div>
        <div class="lang-item" ref="lang">
          <p @click="langData.show = !langData.show">
            {{ langData.arr[langData.current]==='ENGLISH'?`${langData.arr[langData.current]} / 中文`:langData.arr[langData.current] }}
          </p>
          <ul class="drop-list" v-show="langData.show">
            <li
              @click="setLang(index)"
              :class="{ on: langData.current === index }"
              v-for="(item, index) in langData.arr"
              :key="index"
            >
              {{ item }}
            </li>
          </ul>
        </div>
      </div>
      <div class="app-register">
        <router-link
          :to="{ path: '/register', query: { type: 0 } }"
          class="link"
          >{{ $t('common.student') }}</router-link
        >
      </div>
    </div>
    <div id="phoneHeader">
      <ul>
        <li>
          <router-link to="/home" active-class="on">{{
            $t('nav1')
          }}</router-link>
        </li>
        <li>
          <router-link to="/teachers" active-class="on">{{
            $t('nav2')
          }}</router-link>
        </li>
        <li>
          <router-link to="/system" active-class="on">{{
            $t('nav3')
          }}</router-link>
        </li>
        <li>
          <router-link to="/channel" active-class="on">{{
            $t('nav4')
          }}</router-link>
        </li>
        <li>
          <router-link to="/about" active-class="on">{{
            $t('nav5')
          }}</router-link>
        </li>
      </ul>
    </div>
    <nav class="nav">
      <div class="article">
        <a href="" class="logo">
          <!-- <p class="name">{{ $t('logo') }}</p>
          <p class="slogan">{{ $t('slogan') }}</p> -->
        </a>
        <div class="list">
          <router-link to="/home" active-class="on">{{
            $t('nav1')
          }}</router-link>
          <router-link to="/teachers" active-class="on">{{
            $t('nav2')
          }}</router-link>
          <router-link to="/system" active-class="on">{{
            $t('nav3')
          }}</router-link>
          <router-link to="/channel" active-class="on">{{
            $t('nav4')
          }}</router-link>
          <router-link to="/about" active-class="on">{{
            $t('nav5')
          }}</router-link>
        </div>
      </div>
    </nav>
  </header>
</template>
<script>
import { logout } from '@/service/loginAndRegistApi.js'
import { getBaseProfile } from '@/service/teacherApi.js'
import { getMyProfile } from '@/service/studentApi.js'
export default {
  data() {
    return {
      langData: {
        show: false,
        current: 2,
        arr: ['简体中文', '繁體中文', 'ENGLISH'],
      },
      userDown: false,
    }
  },
  computed: {
    user() {
      return JSON.parse(this.$store.getters.GETUSER)
    },
  },
  methods: {
    langDataShow() {
      this.langData.show = true
      this.$forceUpdate()
    },
    async loginout() {
      let res = await logout()
      if (res.data.status === 1) {
        this.$store.dispatch('SETUSER', { loginState: false })
        this.$message({
          message: res.data.descript,
          type: 'success',
        })
        this.userDown = false
        sessionStorage.setItem('token', '')
        this.$router.push({ path: '/home' })
      } else {
        this.$message.error(res.data.descript)
      }
    },
    setLang(index) {
      this.$router.replace({ path: '/' });
      this.langData.current = index
      let langs = ''
      switch (index) {
        case 0:
          langs = 'cn'
          break
        case 1:
          langs = 'TW'
          break
        case 2:
          langs = 'en'
          break
      }
      this.langData.show = false
      this.$emit('changeLang', langs)
    },
    linkto(url) {
      this.$router.push({ path: url })
      this.userDown = false
    },
  },
  async mounted() {
    // 下拉打开时，点击任意位置收起下拉框
    // let lang = this.$refs.lang
    // let lang1 = this.$refs.lang1
    // let user = this.$refs.user
    // document.addEventListener('click', (e) => {
    //   if (!lang.contains(e.target)) {
    //     this.langData.show = false
    //   }
    //   if (!user.contains(e.target)) {
    //     this.userDown = false
    //   }
    //   if (!lang1.contains(e.target)) {
    //     this.langData.show = false
    //   }
    // })

    // 设置默认的语言
    let langs = localStorage.getItem('lang')
    if (!langs) {
      langs = 'en'
    }
    switch (langs) {
      case 'cn':
        this.langData.current = 0
        break
      case 'TW':
        this.langData.current = 1
        break
      case 'en':
        this.langData.current = 2
        break
    }
    this.$emit('changeLang', langs)
    let user=this.user;
    let res1
    if (user.userType === 20) {
      res1 = await getBaseProfile({ teacherId: this.user.uid })
      if (res1.data.status === 1) {
        user.state = res1.data.data.state
        this.$store.dispatch('SETUSER', user)
      }
    } else if(user.userType === 10){
      res1 = await getMyProfile()
      if (res1.status === 200) {
        user.state = res1.data.state
        this.$store.dispatch('SETUSER', user)
      }
    }
  },
}
</script>
<style scoped>
#phoneHeader .on{
  z-index: 999;
  color: rgb(173, 214, 238)!important;
}
</style>
<style lang="scss" scoped>

header{
  position: sticky;
  top: 0;
  z-index: 999;
}
#phoneHeader {
  display: none;
}
#phoneHeader ul {
  height: auto;
  // font-weight: bold;
}
.teacher-change-btn {
  margin-right: 45px;
}
.teacher-change-btn:hover {
  color: #666;
}
.top {
  height: 48px;
  background: #fbfbfb;
  line-height: 48px;
}
.phone {
  display: inline-block;
  vertical-align: middle;
  height: 32px;
  padding-left: 48px;
  line-height: 32px;
  color: #707070;
  background: url(../assets/phone.png) no-repeat left center;
}
.right {
  float: right;
  display: flex;
}
.lang-item {
  display: inline-block;
  position: relative;
  vertical-align: top;
  cursor: pointer;
  color: #999;
  font-weight: 700;
  & > p:hover {
    color: #666;
  }
}
.drop-list {
  position: absolute;
  top: 41px;
  left: 50%;
  margin-left: -50px;
  min-width: 100px;
  background: #fff;
  border-radius: 10px;
  box-shadow: 0 3px 7px rgba(0, 0, 0, 0.16);
  padding: 5px 0;
  z-index: 99;
  li {
    line-height: 30px;
    padding: 0 20px;
    transition: color 0.3s;
    white-space: nowrap;
    &.on,
    &:hover {
      color: #002147;
    }
  }
}
.link {
  color: #999;
  margin-left: 45px;
  &.login {
    padding-left: 20px;
    display: inline-block;
    margin-right: 46px;
    vertical-align: middle;
    height: 24px;
    line-height: 24px;
    background: url(../assets/user.png) no-repeat left center;
  }
  &:hover {
    color: #666;
  }
}
.messega {
  display: inline-block;
  width: 19px;
  height: 21px;
  margin: 0 120px 0 80px;
  vertical-align: middle;
  background: url(../assets/user-config.png);
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
  .num {
    position: absolute;
    left: 10px;
    top: -1px;
    line-height: 13px;
    height: 13px;
    border-radius: 13px;
    padding: 0 3px;
    font-size: 12px;
    background: #f00;
    color: #fff;
  }
}
.user-item {
  display: inline-block;
  min-width: 142px;
  position: relative;
  color: #999;
  cursor: pointer;
  .drop-list {
    left: 50%;
    margin-left: -80px;
  }
}
.user {
  &:after {
    content: '';
    display: block;
    clear: both;
  }
  .avatar {
    float: left;
    width: 24px;
    height: 24px;
    margin-top: 12px;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
    font-size: 0;
  }
  img {
    width: 100%;
    height: 100%;
  }
  &:hover {
    color: #666;
  }
}
.nav {
  height: 80px;
  background: #002147;
}
.logo {
  float: left;
  padding: 10px 0 0;
  width: 117px;
  height: 60px;
  background: url(../assets/logo2.png);
  margin-top: 10px;
}
.name {
  font-size: 32px;
  font-weight: bold;
  line-height: 42px;
}
.slogan {
  font-size: 16px;
  line-height: 18px;
}
.list {
  float: right;
  font-size: 0;
  a {
    display: inline-block;
    vertical-align: top;
    font-size: 18px;
    color: #fff;
    line-height: 80px;
    padding: 0 36px;
    transition: opacity 0.3s;
    &:hover {
      opacity: 0.7;
    }
    &.on {
      background: linear-gradient(to bottom, #a9c4b1, #b3d2a8);
      opacity: 1;
    }
  }
}
.app-logo,
.app-lang,
.app-register {
  display: none;
}
</style>
<style lang="scss" scoped>
@media screen and (max-width: 768px) {
  .top,
  .nav {
    display: none;
  }
  #phoneHeader {
    background: #002147;
    display: block;
    a {
      color: #fff;
    }
  }
  .app-logo {
    display: block;
    padding: 10px 0;
    // text-align: center;
    img {
      margin-left: 20px;
    }
    background: #a9c4b1;
  }
  #phoneHeader {
    ul::-webkit-scrollbar {
      display: none;
    }
    .active {
      color: #cd1845;
      font-weight: bolder;
    }
    width: 100%;
    overflow: hidden;
    padding: 8px;
    ul {
      display: flex;
      align-items: center;
      overflow: auto;
      padding-left: 0;
      list-style: none;
      li {
        flex: 1;
        width: 20%;
        text-align: center;
        font-size: 3.5vw;
        -ms-flex-negative: 0;
        flex-shrink: 0;
        // background: red;
        // margin: 5px;
      }
    }
  }
  .app-register {
    font-weight: 700;
    display: block;
    top: 46px;
    right: 40px;
    position: absolute;
    a {
      color: #fff;
    }
  }
  .app-lang {
    display: block;
    top: 15px;
    right: 40px;
    position: absolute;
    .lang-item {
      color: #fff;
      .drop-list {
        color: #000;
      }
    }
  }
}
</style>
<i18n>
{
  "cn": {
    "info": "个人中心",
    "logout": "退出登录"
  },
  "TW": {
    "info": "個人中心",
    "logout": "登出"
  },
  "en": {
    "info": "Edit Info",
    "logout": "Log out"
  }
}
</i18n>
